import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ChatContainerStyles, ContainerStyle, PageBackgroundStyle, PageTitleStyle, PageTitleStyleVariant, SmallPrintStyle, SmallPrintStyleAtIntro } from './styles';
import BackgroundComponent from './Background/Background';
import DemoInputComponent from './DemoInputComponent/DemoInputComponent';
import ChatUI from '../ChatUI';
import { useGlobalState } from '../../GlobalStateContext';

interface SmallPrintComponentProps {
	displaysAtIntro: boolean;
}

const SmallPrintComponent: React.FC<SmallPrintComponentProps> = ({ displaysAtIntro }) => {
	return (
		<Typography sx={displaysAtIntro ? SmallPrintStyleAtIntro : SmallPrintStyle} className='animate__animated animate__fadeIn'>
			Asistente virtual desarrollo con Xami-CX, nuestra plataforma de IA generativa. Las respuestas generadas por IA pueden ser inexactas; verifica la información. Al usar este servicio, aceptas nuestra <a href="https://codster.io/aviso-de-privacidad/" target='_blank' rel='noreferrer'>Política de Privacidad</a>.
		</Typography>
	);
};

const DemoComponent: React.FC = () => {
	const { state: globalState } = useGlobalState();
	const chatbotSettings = globalState?.chatbotSettings;
	const chatbotTypeList = globalState?.chatbotTypeList;
	const APIError = globalState?.setAPIError;
	const appType = chatbotSettings?.app_type;
	const [showChat, setShowChat] = useState(false);
	const [input, setInput] = useState('');

	const urlParams = new URLSearchParams(window.location.search);
	const headerText = urlParams.get('header_text') || '¿Problema complicado?';
	const subtitleText = urlParams.get('subtitle_text') || 'Empecemos por una conversación simple:';
	const inputPlaceholder = urlParams.get('input_placeholder') || '¿Qué solución tecnológica estás buscando hoy?';

	return (
		<>
			{appType && chatbotTypeList && (
				<Box sx={{...PageBackgroundStyle}}>
					<BackgroundComponent></BackgroundComponent>
					<Box>
						<Box sx={{...ContainerStyle, display: showChat ? 'none' : 'block'}}>
							<Box sx={{ padding: '16px' }}>
								<Typography variant='h1' sx={PageTitleStyle}>
									<span className='animate__animated animate__fadeInDown' style={{ animationDuration: '0.5s' }}>{headerText}</span><br />
									<span className='animate__animated animate__fadeInDown' style={{...PageTitleStyleVariant, animationDuration: '0.5s', animationDelay: '0.3s'}}>{subtitleText}</span>
								</Typography>
								<Box sx={{ margin: '32px 0 8px 0', animationDelay: '1s' }} className='animate__animated animate__fadeInDown'>
									<DemoInputComponent APIError={APIError} setShowChat={setShowChat} setInput={setInput} input={input} inputPlaceholder={inputPlaceholder}></DemoInputComponent>
								</Box>
								<SmallPrintComponent displaysAtIntro={true}></SmallPrintComponent>
							</Box>
						</Box>
						<Box sx={{...ChatContainerStyles, display: showChat ? 'block' : 'none'}}>
							<ChatUI appType={appType} typeList={chatbotTypeList} setShowChat={setShowChat} setInput={setInput} input={input} showChat={showChat} inputPlaceholder={inputPlaceholder} />
							<SmallPrintComponent displaysAtIntro={false}></SmallPrintComponent>
						</Box>
					</Box>
				</Box>
			)}
		</>
	);
};

export default DemoComponent;